import type { HTMLAttributes } from 'react';

/** Matches App.tsx's shell card exactly (`rounded-none border border-border bg-card`). */
export function Card({ className = '', ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={`rounded-none border border-border bg-card ${className}`} {...props} />;
}
